const DeliverIQPage = () => {
  return (
    <div data-testid="deliveriq-page" className="pt-20 min-h-screen bg-slate-950">
      <iframe
        src="https://proof-track-1.emergent.host"
        title="DeliverIQ - Proof of Delivery"
        className="w-full h-[calc(100vh-80px)] border-0"
        allow="geolocation; camera; microphone; clipboard-write; fullscreen"
        allowFullScreen
      />
    </div>
  );
};

export default DeliverIQPage;
